export const WIDTH_BOUNDARY_SMALL = '835px';
export const WIDTH_BOUNDARY_SMALLEST = '500px';
